module.exports = __webpack_public_path__ + "img/New Jersey.2dd2bc09.png";